    (function () {
      // ── 定数 ──────────────────────────────
      const MONTH_EN = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE',
                        'JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'];
      const MONTH_JA = ['1月','2月','3月','4月','5月','6月',
                        '7月','8月','9月','10月','11月','12月'];
      const DOW      = ['日','月','火','水','木','金','土'];

      // ── 現在時刻から当月・翌月を算出 ────────
      const now        = new Date();
      const thisYear   = now.getFullYear();
      const thisMonth  = now.getMonth(); // 0-indexed

      const nextDate   = new Date(thisYear, thisMonth + 1, 1);
      const nextYear   = nextDate.getFullYear();
      const nextMonth  = nextDate.getMonth();

      // 例として使う申込み日
      const chargeDay1  = 10; // ケース1: 15日以前
      const chargeDay2  = 20; // ケース2: 16日以降

      // ── カレンダーHTML生成 ──────────────────
      function daysInMonth(y, m) {
        return new Date(y, m + 1, 0).getDate();
      }

      function buildCalendar(year, month, opts) {
        // opts: { chargeDay, chargeDayClass, cutoff:15, shipDay:18, nextChargeDay, nextChargeDayClass }
        const firstDow = new Date(year, month, 1).getDay();
        const total    = daysInMonth(year, month);
        const label    = `${MONTH_EN[month]} — ${MONTH_JA[month]}`;

        let grid = DOW.map(d => `<div class="cal-dow">${d}</div>`).join('');
        // 空白
        for (let i = 0; i < firstDow; i++) grid += `<div class="cal-day empty">&nbsp;</div>`;

        for (let d = 1; d <= total; d++) {
          let cls = 'cal-day';
          let badge = '';
          if (opts.cutoff && d === opts.cutoff) {
            cls += ' cutoff-last';
            badge = opts.cutoffLabel || '締切';
          } else if (opts.chargeDay && d === opts.chargeDay) {
            cls += ` ${opts.chargeDayClass || 'charge-day'}`;
            badge = opts.chargeDayLabel || '申込&amp;請求';
          } else if (opts.shipDay && d === opts.shipDay) {
            cls += ' ship-day';
            badge = '発送';
          } else if (opts.nextChargeDay && d === opts.nextChargeDay) {
            cls += ` ${opts.nextChargeDayClass || 'charge-day2'}`;
            badge = opts.nextChargeDayLabel || '自動請求';
          }
          const badgeHtml = badge ? `<span class="cal-badge">${badge}</span>` : '';
          grid += `<div class="${cls}">${d}${badgeHtml}</div>`;
        }

        return `
          <div class="cal-block">
            <div class="cal-month">${label}</div>
            <div class="cal-grid">${grid}</div>
          </div>`;
      }

      // ── タイムラインHTML生成 ────────────────
      function btlItem(date, text, tag, isLast) {
        const tagHtml = tag ? `<span class="btl-tag ${tag.cls}">${tag.label}</span>` : '';
        const lineHtml = isLast ? '' : '<div class="btl-line"></div>';
        return `
          <div class="btl-item">
            <div class="btl-left"><div class="btl-dot filled"></div>${lineHtml}</div>
            <div class="btl-content${isLast ? ' style="padding-bottom:0;"' : ''}">
              <p class="btl-date">${date}</p>
              <p class="btl-text">${text}${tagHtml}</p>
            </div>
          </div>`;
      }

      function fmt(m, d) {
        return `${MONTH_JA[m]}${d}日`;
      }

      // ── ケース1: 当月15日以前申込み ──────────
      const cal1a = buildCalendar(thisYear, thisMonth, {
        chargeDay: chargeDay1, chargeDayClass: 'charge-day', chargeDayLabel: '申込&amp;請求',
        cutoff: 15, shipDay: 18
      });
      const cal1b = buildCalendar(nextYear, nextMonth, {
        nextChargeDay: chargeDay1, nextChargeDayClass: 'charge-day2', nextChargeDayLabel: '自動請求',
        cutoff: 15, shipDay: 18
      });
      const tl1 = `
        <div class="billing-timeline-list" style="margin-top:20px;">
          ${btlItem(fmt(thisMonth, chargeDay1), `申込み・初回請求（¥1,800）`, {cls:'green', label:'✓ 当月締切前'})}
          ${btlItem(fmt(thisMonth, 15), `発送締め切り — ${chargeDay1}日申込みのため当月対象`)}
          ${btlItem(fmt(thisMonth, 18), `${MONTH_JA[thisMonth]}号のアートレターを発送 ✉️`)}
          <div class="btl-item">
            <div class="btl-left"><div class="btl-dot"></div></div>
            <div class="btl-content" style="padding-bottom:0;">
              <p class="btl-date">${fmt(nextMonth, chargeDay1)}（以降毎月${chargeDay1}日）</p>
              <p class="btl-text">自動更新・請求（¥1,800）→ ${MONTH_JA[nextMonth]}号を発送</p>
            </div>
          </div>
        </div>`;

      // ── ケース2: 当月16日以降申込み ──────────
      const cal2a = buildCalendar(thisYear, thisMonth, {
        cutoff: 15, cutoffLabel: '締切済',
        chargeDay: chargeDay2, chargeDayClass: 'charge-day', chargeDayLabel: '申込&amp;請求'
      });
      const cal2b = buildCalendar(nextYear, nextMonth, {
        cutoff: 15, shipDay: 18,
        nextChargeDay: chargeDay2, nextChargeDayClass: 'charge-day2', nextChargeDayLabel: '自動請求'
      });
      const tl2 = `
        <div class="billing-timeline-list" style="margin-top:20px;">
          ${btlItem(fmt(thisMonth, chargeDay2), `申込み・初回請求（¥1,800）`, {cls:'amber', label:'締切後のため翌月から'})}
          ${btlItem(fmt(nextMonth, 15), `発送締め切り — ${chargeDay2}日申込みのため${MONTH_JA[nextMonth]}対象`)}
          ${btlItem(fmt(nextMonth, 18), `${MONTH_JA[nextMonth]}号のアートレターを発送 ✉️`)}
          <div class="btl-item">
            <div class="btl-left"><div class="btl-dot"></div></div>
            <div class="btl-content" style="padding-bottom:0;">
              <p class="btl-date">${fmt(nextMonth, chargeDay2)}（以降毎月${chargeDay2}日）</p>
              <p class="btl-text">自動更新・請求（¥1,800）→ 翌々月号を発送</p>
            </div>
          </div>
        </div>`;

      // ── DOM組み立て ──────────────────────────
      const tabsEl = document.getElementById('billing-tabs');
      tabsEl.innerHTML = `
        <button class="billing-tab active" data-case="0">
          <span class="tab-date">〜 15日まで</span>当月に届くケース
        </button>
        <button class="billing-tab" data-case="1">
          <span class="tab-date">16日 〜</span>翌月から届くケース
        </button>`;

      const panelsEl = document.getElementById('billing-panels');
      panelsEl.innerHTML = `
        <div class="billing-panel active" id="case0">
          <div class="cal-wrap">${cal1a}${cal1b}</div>${tl1}
        </div>
        <div class="billing-panel" id="case1">
          <div class="cal-wrap">${cal2a}${cal2b}</div>${tl2}
        </div>`;

      // ── タブ切り替え ──────────────────────────
      tabsEl.addEventListener('click', function (e) {
        const btn = e.target.closest('.billing-tab');
        if (!btn) return;
        const idx = btn.dataset.case;
        tabsEl.querySelectorAll('.billing-tab').forEach(t => t.classList.remove('active'));
        btn.classList.add('active');
        panelsEl.querySelectorAll('.billing-panel').forEach(p => p.classList.remove('active'));
        document.getElementById('case' + idx).classList.add('active');
      });
    })();